export default {
  row: {
    display: 'flex',
    gap: '20px',
    '& .MuiAutocomplete-root': {
      padding: 0,
    },
    '& .MuiPaper-root': {
      background: '#fff !important',
    },
    '& .MuiAutocomplete-listbox': {
      padding: '0 !important',
    },
    '& .MuiPopper-root': {
      padding: '0 !important',
      background: '#fff !important',
    },
  },
};
